module.exports = __webpack_public_path__ + "img/CrucesServicio.6a25fa35.jpeg";